import React from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "./components/AppLayout";

import Home from "./pages/Home";
import ConsumerOnboarding from "./pages/ConsumerOnboarding";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PartnershipPrograms from "./pages/PartnershipPrograms";
import AboutPartnership from "./pages/AboutPartnership";
import CalendarPage from "./pages/CalendarPage"
import CommunityMeetupRegistrationPage from "./pages/CommunityMeetupRegistrationPage";
import EventRegistrationPage from "./pages/EventRegistrationPage";
import MyRegistrations from "./pages/MyRegistrations";
import CertificateVerificationPage from "./pages/CertificateVerificationPage";
import LandingPage from "./pages/LandingPage";
import EnterpriseManagement from "./pages/EnterpriseManagement";

import Login from "./pages/Login";

import Companies from "../../components/Companies"

import Opportunity from "../../components/opportunities"
import Events from "../../components/Events"
import Request from "../../components/Request"

import AdminDashboard  from "../../components/AdminDashboard"

import ProtectedRoute from "../ProtectedRoute";
import ProfileUpdate from "../ProfileUpdate";
import UpdatePassword from "../UpdatePassword";
import InitialPasswordSetup from "../InitialPasswordSetup";
import IndustryDetails from "../IndustryDetails";

const UdyogConnect = () => {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="login" element={<Login />} />
        <Route path="set-password" element={<InitialPasswordSetup />} />
        <Route index element={<Home />} />
        <Route path="consumer-onboarding" element={<ConsumerOnboarding />} />
        <Route path="about" element={<About />} />
        <Route path="partnership-programs" element={<PartnershipPrograms />} />
        <Route path="about-partnership" element={<AboutPartnership />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="community-meetup/:meetupKey/register" element={<CommunityMeetupRegistrationPage />} />
        <Route path="event/:eventKey/register" element={<EventRegistrationPage />} />
        <Route path="certificates/verify/:publicId" element={<CertificateVerificationPage />} />
        <Route path="udyogconnect-home" element={<LandingPage />} />
        {/* <Route path="contact" element={<Contact />} /> */}
        <Route element={<ProtectedRoute />}>
          <Route path="companies" element={<Companies />} />
          <Route path="opportunities" element={<Opportunity />} />
          <Route path="events" element={<Events />} />
          <Route path="request" element={<Request />} />
          <Route path="admin" element={<AdminDashboard />} />
          <Route path="profile-update" element={<ProfileUpdate />} />
          <Route path="my-registrations" element={<MyRegistrations />} />
          <Route path="updatepassword" element={<UpdatePassword />} />
          <Route path="industry/:name" element={<IndustryDetails />} />
          <Route path="enterprise-management" element={<EnterpriseManagement />} />
        </Route>        
        </Route>
    </Routes>

    // <Route element={<ProtectedRoute />}>
    //   <Route element={<Layout />}>
    //     <Route path="home" element={<HomePage />} />
    //     <Route path="about" element={<About />} />
    //     <Route path="companies" element={<Companies />} />
    //     <Route path="request" element={<Request />} />
    //     <Route path="admin" element={<AdminDashboard />} />
    //     <Route path="profile-update" element={<ProfileUpdate />} />
    //     <Route path="opportunities" element={<Opportunity />} />
    //     <Route path="industry/:name" element={<IndustryDetails />} />
    //     <Route path="updatepassword" element={<UpdatePassword />} />
    //     <Route path="events" element={<Events />} />  
    //     <Route path="techsummit-register" element={<TechsubmitRegistrationPage />} />  
    //   </Route>
    // </Route>
  );
};

export default UdyogConnect;
